import { Box, Typography, Button, styled, TextField } from "@mui/material"
import { colors } from "../../../theme/colors"
import UIIcon from "../../../components/UIIcon"
import { WhiteCard } from "../../../components/styled"

export const IconContainer = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "auto",
})

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  width: "100%",
})

export const BankCard = styled(WhiteCard)({
  width: "100%",
  boxSizing: "border-box",
  margin: "30px 0",
  display: "flex",
  flexDirection: "column",
})

export const CardTopContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 20,
})

export const CardLabel = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 18,
  lineHeight: "24px",
  fontWeight: 500,
})

export const ChangeBank = styled(Button)({
  display: "contents",
})

export const MessageInput = styled(TextField)({
  marginTop: 30,
})

export const SBPIcon = styled(UIIcon)({
  margin: "auto auto 0 auto",
})

export const ContinueButton = styled(Button)({
  marginTop: 10,
})

export const SBPAgreementLink = styled("a")({
  display: "inline-block",
})

export const StyledButton = styled(Button)({
  marginTop: "auto",
})

export const CheckboxContainer = styled(Box)({
  marginTop: 16,
  marginBottom: 10,
  display: "flex",
  gap: 20,
  flexWrap: "nowrap",
  textAlign: "start",
  "& .MuiButtonBase-root": {
    padding: 0,
  },
  "& .MuiTypography-root": {
    textAlign: "start",
    "& a": {
      color: colors.blue,
    },
  },
})

export const ButtonTransfer = {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}
